export default __webpack_public_path__ + "static/media/Themu.8c5fabe6.mp4";